import Tooltips from "../tooltips";
import {getTableColumnTooltip} from "@/utils/tooltipsProvider";

export const relatedKeywordsTableConfig = {
    headers: [
        {
            text: 'Keywords',
            sortable: true,
            isActive: true,
            isHideable: false,
            value: 'keyword',
            sortBy: 'keyword',
            align: 'left',
            hasCheckbox: true,
            hasExtendedHeader: true,
            headingClass: 'keywords-column',
            sortArrowsAlign: 'right',
        },
        {
            text: 'Popularity',
            sortable: true,
            isActive: true,
            isHideable: true,
            value: 'sap',
            sortBy: 'sap',
            align: 'right',
            headingClass: 'sap-column',
            tooltipWidth: '280px',
            tooltipDirection: 'left',
            tooltipText: getTableColumnTooltip('popularity', 'APP_STORE'),
        },
        {
            text: 'Daily Impr',
            value: 'daily_impression',
            sortBy: 'daily_impression',
            align: 'right',
            sortable: true,
            isActive: true,
            isHideable: true,
            headingClass: 'impressions-column',
            tooltipWidth: '300px',
            tooltipDirection: 'left',
            tooltipText: getTableColumnTooltip('est_impressions', 'APP_STORE'),
        },
        {
            text: 'Difficulty',
            value: 'difficulty',
            sortBy: 'difficulty',
            align: 'right',
            sortable: true,
            isActive: true,
            isHideable: true,
            headingClass: 'difficulty-column',
            tooltipWidth: '248px',
            tooltipDirection: 'left',
            tooltipText: getTableColumnTooltip('difficulty', 'APP_STORE'),

        },
        {
            text: 'App Rank',
            value: 'rank',
            sortBy: 'rank',
            align: 'right',
            sortable: true,
            isActive: true,
            isHideable: true,
            headingClass: 'rank-column',
            tooltipWidth: '248px',
            tooltipDirection: 'right',
            tooltipText: getTableColumnTooltip('rank', 'APP_STORE'),
        },
        {
            text: 'Results',
            value: 'applications_count',
            sortBy: 'applications_count',
            align: 'right',
            sortable: true,
            isActive: true,
            isHideable: true,
            headingClass: 'results-column',
            tooltipWidth: '248px',
            tooltipDirection: 'right',
            tooltipText: getTableColumnTooltip('results', 'APP_STORE'),
        },
        {
            text: 'Comp. in Top 10',
            value: 'competitors_top',
            sortBy: 'top_competitors',
            align: 'right',
            sortable: true,
            isActive: true,
            isHideable: true,
            headingClass: 'comp-top-column',
            tooltipWidth: '248px',
            tooltipDirection: 'right',
            tooltipText: getTableColumnTooltip('comp_in_top_10', 'APP_STORE'),
        },
    ],
}
